import { createFileRoute } from '@tanstack/react-router'
import { StandingsTable } from '../components/StandingsTable'

// The current season's table (designs/20261017-seasons.md §4). A season's
// own page is /l/{slug}/s/{n}/standings.
export const Route = createFileRoute('/l/$slug/standings')({ component: Standings })

function Standings() {
  const { slug } = Route.useParams()
  return <StandingsTable slug={slug} />
}
